module.exports = __webpack_public_path__ + "static/media/Cabinet3_After.78e95913.jpg";